import {TranslateService} from '@ngx-translate/core';
import {LanguageFr} from './language.fr';
import {LanguageEn} from './language.en';
import {ILanguage} from './language';
import {LanguageFrFR} from "./language.fr.FR";

export class MyTranslateHttpLoader /*implements TranslateLoader*/ {
    // constructor(private http: Http, private prefix: string, private suffix: string) {
    //     // console.log('prefix: ' + prefix + ' prefix: ' + this.prefix);
    // }

    public populateTranslate(langCountry: string, translate: TranslateService){
        translate.getLangs().push(langCountry);
        let lang: ILanguage;
         // let lang: LanguageFr;
        console.log('langCountry is >' + langCountry+'<');
        if ( langCountry === 'fr' || langCountry === 'fr-CA' ) {
            lang = new LanguageFr();
        }else if (langCountry === 'fr-FR'){
            console.log('Using fr-FR configuration');
            lang = new LanguageFrFR();
        } else {
            lang = new LanguageEn();
        }
        // console.log('Working on ' + JSON.stringify(lang) + ' ' + lang.HELLO);
        let array = Object.getOwnPropertyNames(lang);

        for (let i = 0; i < array.length; i++ ) {
            // console.log('Working on ' + array[i] + ' ' + langCountry);
            translate.set(array[i], lang[array[i]], langCountry );

        }

    }

    /**
     * Gets the translations from the server
     * @param lang
     * @returns {any}
     */
    /*
    public getTranslation(langCountry: string ): Observable<any> {
        let lang: string;
        console.log('getTranslation getting in... ' + langCountry);

        let idx = langCountry.indexOf('_');
        if ( idx >= 0 ) {
           lang = langCountry.substr(0, idx);
        }
       return Observable.of(this.loadTranslation(langCountry).then(
           firstLevel => {
               // console.log('Load firstLevel ' + langCountry);
               if (idx >= 0) {
                   this.loadTranslation(lang).then( secondLevel => {
                       // console.log('Trying to merge with ' + lang);
                       // firstLevel aka fr_CA superseedes fr.
                       let output = {...secondLevel, ...firstLevel };
                       console.log('output: ' + JSON.stringify(output));
                       return output;
                   });
               }else {
                   console.log('output: ' + JSON.stringify(firstLevel));
                    return firstLevel;
               }
           }
       ));

    }

    private loadTranslation( url: string ): Promise<any> {
        let url2 = `${this.prefix}${url}${this.suffix}`;
        console.log('loadTranslation trying to retrieve ' + url2);
        return this.http.get(url2).toPromise().then(
                response => {return response.json() as any; }
            ).catch(this.handleError);
    }


    private handleError(error: any): Promise<any> {
        console.error('*Http* -> An error occurred', error);
        return Promise.reject(error.message || error);
    }
    */


}
